import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Hotels from "./pages/Hotels";
import Dubai from "./pages/Dubai";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import OnlineReservation from "./pages/OnlineReservation";
import AgencyForm from "./pages/AgencyForm";
import Cyprus from "./pages/Cyprus";
import Bali from "./pages/Bali";
import Egypt from "./pages/Egypt";
import Thailand from "./pages/Thailand";
import Balkans from "./pages/Balkans";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hotels" element={<Hotels />} />
            <Route path="/dubai" element={<Dubai />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/online-reservation" element={<OnlineReservation />} />
            <Route path="/agency-form" element={<AgencyForm />} />
            <Route path="/cyprus" element={<Cyprus />} />
            <Route path="/bali" element={<Bali />} />
            <Route path="/egypt" element={<Egypt />} />
            <Route path="/thailand" element={<Thailand />} />
            <Route path="/balkans" element={<Balkans />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
